export default "__VITE_PUBLIC_ASSET__bd352346__"